var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "table",
        {
          staticClass: "col-md-12",
          attrs: { cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(0),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrayDocumentosNecessarios.length == 0,
                      expression: "arrayDocumentosNecessarios.length == 0"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "50" } },
                    [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                  )
                ]
              ),
              _vm._l(_vm.arrayDocumentosNecessarios, function(doc) {
                return _c("tr", { key: doc.a }, [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(doc.documento.nomDocumento) +
                        "\n          "
                    )
                  ])
                ])
              })
            ],
            2
          )
        ]
      )
    ]),
    _vm._m(1),
    _c("div", { staticClass: "row" }, [
      _c(
        "table",
        {
          staticClass: "col-md-12",
          attrs: { cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(2),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrayDadosAnexadosProcesso.length == 0,
                      expression: "arrayDadosAnexadosProcesso.length == 0"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "50" } },
                    [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                  )
                ]
              ),
              _vm._l(_vm.arrayDadosAnexadosProcesso, function(obs) {
                return _c("tr", { key: obs.codAnexo }, [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.documento.nomDocumento) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.txtObservacao) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.formatarDisponibilidade(obs.indDisponibilidade)
                        ) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formatarTamanhoArquivo(obs.tamanhoArquivo)) +
                        "\n          "
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "btn-operacao",
                          attrs: {
                            round: "",
                            small: "",
                            flat: "",
                            color: "black"
                          },
                          on: {
                            click: function() {
                              return _vm.baixarAnexo(obs)
                            }
                          }
                        },
                        [
                          _c("q-icon", {
                            attrs: { name: "fas fa-download", size: "18px" }
                          }),
                          _c("q-tooltip", { attrs: { anchor: "top left" } }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "13px" } },
                              [
                                _vm._v(
                                  "\n                  Baixar Arquivo\n                "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        ]
      )
    ]),
    _vm._m(3),
    _c("div", { staticClass: "row" }, [
      _c(
        "table",
        {
          staticClass: "col-md-12",
          attrs: { cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(4),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrayDadosAnexadosSolicitacao.length == 0,
                      expression: "arrayDadosAnexadosSolicitacao.length == 0"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "50" } },
                    [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                  )
                ]
              ),
              _vm._l(_vm.arrayDadosAnexadosSolicitacao, function(obs) {
                return _c("tr", { key: obs.codAnexo }, [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.documento.nomDocumento) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.txtObservacao) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.formatarDisponibilidade(obs.indDisponibilidade)
                        ) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formatarTamanhoArquivo(obs.tamanhoArquivo)) +
                        "\n          "
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "btn-operacao",
                          attrs: {
                            round: "",
                            small: "",
                            flat: "",
                            color: "black"
                          },
                          on: {
                            click: function() {
                              return _vm.baixarAnexo(obs)
                            }
                          }
                        },
                        [
                          _c("q-icon", {
                            attrs: { name: "fas fa-download", size: "18px" }
                          }),
                          _c("q-tooltip", { attrs: { anchor: "top left" } }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "13px" } },
                              [
                                _vm._v(
                                  "\n                  Baixar Arquivo\n                "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "50%" } }, [
          _vm._v("\n            Documentação Obrigatória\n          ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mrg-t-10" }, [
      _c(
        "span",
        {
          staticClass:
            "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
        },
        [_vm._v("\n      Dados da anexação\n    ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Documentos Anexados")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Observação")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Disponível")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Tamanho aproximado do arquivo")
        ]),
        _c("th", { staticClass: "text-right", attrs: { width: "5%" } }, [
          _vm._v("Operação teste")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mrg-t-10" }, [
      _c(
        "span",
        {
          staticClass:
            "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
        },
        [_vm._v("\n      Arquivos anexados na solicitação\n    ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Documentos Anexados")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Observação")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Disponível")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Tamanho aproximado do arquivo")
        ]),
        _c("th", { staticClass: "text-right", attrs: { width: "5%" } }, [
          _vm._v("Operação")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }